<template>
  <div class="price-bar fixed-bar--bar">
    <back-to-dashboard-link />
    <div class="price-bar__prices">
      <div class="price-bar__price">
        <div data-qa="price-bar-total-label">
          {{ i18n.t('/PriceBar/TotalPrice') }}
        </div>
        <div v-if="totalPrice" data-qa="price-bar-total-price">
          {{ i18n.n(totalPrice, 'currency') }}
        </div>
      </div>
      <div v-if="dealerSettings.vwpfsFinanceEnabled" class="price-bar__price">
        <div data-qa="price-bar-financing-label">
          {{ i18n.t('/PriceBar/Financing') }}
        </div>
        <div data-qa="price-bar-financing-price">
          {{ formattedMonthPrice }}
        </div>
      </div>
      <div v-if="dealerSettings.vwpfsPrivateLeaseEnabled" class="price-bar__price">
        <div data-qa="price-bar-private-lease-label">
          {{ i18n.t('/PriceBar/PrivateLease') }}
        </div>
        <div data-qa="price-bar-private-lease-price">
          {{ formattedLeasePrice }}
        </div>
      </div>
      <div v-if="dealerSettings.vwpfsOperationalLeaseEnabled" class="price-bar__price">
        <div data-qa="price-bar-operational-lease-label">
          {{ i18n.t('/PriceBar/OperationalLease') }}
        </div>
        <div data-qa="price-bar-operational-lease-price">
          {{ formattedOperationalLeasePrice }}
        </div>
      </div>
      <div v-if="dealerSettings.vwpfsInsuranceEnabled" class="price-bar__price">
        <div data-qa="price-bar-insurance-label">
          {{ i18n.t('/PriceBar/Insurance') }}
        </div>
        <div data-qa="price-bar-insurance-price">
          {{ formattedInsurancePrice }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BackToDashboardLink from '@/components/generic/presentational/molecules/backToDashboardLink/BackToDashboardLink.vue'
import CurrencyHelper from '@/helpers/currencyHelper'
import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    BackToDashboardLink,
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    ...mapState('user', ['dealerSettings']),
    ...mapGetters({
      totalPrice: 'quote/totalPriceInclBtw',
      latestVwpfsCall: 'quote/latestVwpfsCall',
      latestVwpfsPrivateLeaseCall: 'quote/latestVwpfsPrivateLeaseCall',
      latestVwpfsInsuranceCall: 'quote/latestVwpfsInsuranceCall',
      latestVwpfsOperationalLeaseCall: 'quote/latestVwpfsOperationalLeaseCall',
    }),
    formattedMonthPrice() {
      return this.latestVwpfsCall?.Errors
        ? '-'
        : CurrencyHelper.currencyRoundedDash(this.latestVwpfsCall?.MonthPrice)
    },
    formattedLeasePrice() {
      const rate = this.latestVwpfsPrivateLeaseCall?.response?.pricingData?.calculatedProduct?.rate
      return !this.latestVwpfsPrivateLeaseCall?.response ||
        this.latestVwpfsPrivateLeaseCall.responseCode < 200 ||
        this.latestVwpfsPrivateLeaseCall.responseCode >= 400
        ? '-'
        : CurrencyHelper.currencyRoundedDash(rate?.amountAfterPrePayment ?? rate?.amount)
    },
    formattedOperationalLeasePrice() {
      return !this.latestVwpfsOperationalLeaseCall?.response ||
        this.latestVwpfsOperationalLeaseCall.responseCode < 200 ||
        this.latestVwpfsOperationalLeaseCall.responseCode >= 400
        ? '-'
        : CurrencyHelper.currencyRoundedDash(
            this.latestVwpfsOperationalLeaseCall?.response?.pricingData?.calculatedProduct?.rate
              ?.amount
          )
    },
    formattedInsurancePrice() {
      return !this.latestVwpfsInsuranceCall?.response?.insurance ||
        this.latestVwpfsInsuranceCall.responseCode < 200 ||
        this.latestVwpfsInsuranceCall.responseCode >= 400
        ? '-'
        : CurrencyHelper.currencyRoundedDash(
            this.latestVwpfsInsuranceCall?.response?.insurance?.contract?.premium?.invoiceAmount
          )
    },
  },
}
</script>

<style lang="scss" scoped>
.price-bar {
  padding: 0.5rem 0;

  &__prices {
    display: flex;
  }

  &__price {
    font-weight: $font-weight-bold;
    color: $gray-darker;
    margin: 0 2rem;

    &:first-child {
      margin-left: 0;
    }
    &:last-child {
      margin-right: 0;
    }
  }
}

:deep(.back-to-dashboard) {
  padding-top: 0;
}
</style>
